<template>
	<div class="c-programmation__list__item">
		<div class="o-show-card u-color-white">
			<a :href="date.url" class="o-show-card__link">
				<div class="o-show-card__link__inner">
					<div class="o-show-card__header">
						<div v-if="date.categories.length > 0" class="o-show-category">
							<span class="o-show-category__color" :class="'u-bg-color-' + couleur"></span>
							<span class="o-show-category__label">{{ date.categories[0].name }}</span>
						</div>
					</div>
					<div class="o-show-card__content">
						<div class="o-show-card__content__inner">
							<h2 class="o-show-card__title o-title-4" v-html="date.artiste">
							</h2>
							<div class="o-show-card__description" v-html="date.evenement">
							</div>
						</div>
						<div class="o-show-card__img" v-follow-cursor>
							
							<div class="o-responsive-img" style="padding-top:95.779220779221%">
								<img :src="date.image" :alt="date.title" />
							</div>
							<div v-if="date.labels.length > 0 || date.complet" class="o-show-card__tag__wrapper js-cursor" :class="{ '-tag-10ans': libelle_image }">
								<div v-if="date.complet" class="o-show-card__tag"
									:class="'u-rotate-' + deg + ' u-bg-color-' + couleur">Complet</div>
								<div v-else-if="libelle_image == ''" class="o-show-card__tag"
									:class="'u-rotate-' + deg + ' u-bg-color-' + couleur">{{
										date.labels[0].name }}</div>
								<div v-if="libelle_image" :class="'o-show-card__tag u-rotate-' + deg">
									<img class="o-show-card__tag__img" :src="libelle_image" :alt="libelle_alt" />
								</div>
							</div>
							<div class="o-show-card-dates">
								<div class="o-show-card-dates__item">
									<span class="o-show-card-dates__day">{{ day }}</span>
									<span class="o-show-card-dates__month">{{ monthLocale }}</span>
								</div>
								<Svg v-if="false" id="arrow-full-right" classes="-show-dates" />
								<div v-if="false" class="o-show-card-dates__item">
									<span class="o-show-card-dates__day">16</span>
									<span class="o-show-card-dates__month">Sept.</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</a>
		</div>
	</div>
</template>

<script setup>
import Svg from '@/js/components/Svg.vue';
import { ref } from 'vue';

const props = defineProps(['date']);
const day = ref(
	props.date.date.split('-')[2]
);
const monthLocale = new Date(props.date.date + 'T00:00:00').toLocaleString('fr-CA', {
	month: 'short',
});
const degOptions = ['west', 'north', 'est'];
const deg = degOptions[Math.floor(Math.random() * degOptions.length)];
const couleur = ref(props.date.categories.length > 0 && props.date.categories[0].couleur !== undefined ? props.date.categories[0].couleur : 1);

let libelle_image = '';
let libelle_alt = '';
props.date.labels.forEach((label) => {
	if (label.image) {
		libelle_image = label.image;
		libelle_alt = label.name;
	}
});
</script>
